// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/StarRating/styles.css
// module id = 3720
// module chunks = 29